import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/calculators/iczin/eagle.png'
import _imports_1 from '@/assets/calculators/iczin/tails.png'


const _hoisted_1 = { class: "w-full flex flex-col items-center" }
const _hoisted_2 = { class: "flex justify-center gap-5 md:gap-[36px] mb-4 md:mb-6" }
const _hoisted_3 = { class: "text-xl font-bold mb-10 text-center text-brown" }


import { ICzinCoinState } from "@/types/calculators";
import ResultStack from "@/views/Calculators/ICzinPrediction/components/ResultStack.vue";
import GradientButton from "@/components/buttons/GradientButton.vue";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'CoinThrower',
  props: {
    coins: {},
    results: {},
    isFlipping: { type: Boolean },
    isLoading: { type: Boolean }
  },
  emits: ["flip"],
  setup(__props: any) {





const { t } = useI18n();

function getCoinStyle(coin: ICzinCoinState) {
  return {
    transform: `rotateY(${coin.angle}deg)`,
    transition: "transform 0.8s cubic-bezier(.23,1.09,.7,1.06)",
  };
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.coins, (coin, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: idx,
          class: "relative size-[90px] md:size-40 [perspective:350px] [transform-style:preserve-3d] [transition:transform_0.8s_cubic-bezier(0.23,1.09,0.7,1.06)]",
          style: _normalizeStyle(getCoinStyle(coin))
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("div", { class: "absolute top-0 left-0 w-full h-full flex items-center justify-center rounded-full shadow-[0_2px_12px_rgba(120,122,168,0.07)] [backface-visibility:hidden] [transform:rotateY(0deg)]" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "Орёл",
              class: "size-[90px] md:size-40 select-none pointer-events-none"
            })
          ], -1),
          _createElementVNode("div", { class: "absolute top-0 left-0 w-full h-full flex items-center justify-center rounded-full shadow-[0_2px_12px_rgba(120,122,168,0.07)] [backface-visibility:hidden] [transform:rotateY(180deg)]" }, [
            _createElementVNode("img", {
              src: _imports_1,
              alt: "Решка",
              class: "size-[90px] md:size-40 select-none pointer-events-none"
            })
          ], -1)
        ]))], 4))
      }), 128))
    ]),
    _createVNode(ResultStack, {
      results: __props.results,
      class: "mb-4"
    }, null, 8, ["results"]),
    _createVNode(GradientButton, {
      class: "w-[263px] min-h-14 mb-4",
      "bg-color": "bg-brown-gradient",
      "hover-bg-color": "bg-orange-gradient",
      text: _unref(t)('calculators.iczin.throw-coins-btn'),
      disabled: __props.isFlipping || __props.results.length >= 6,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('flip'))),
      "is-loading": __props.isLoading
    }, null, 8, ["text", "disabled", "is-loading"]),
    _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(t)("calculators.iczin.need-to-throw", { count: 6 - __props.results.length })), 1)
  ]))
}
}

})